import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import get from 'lodash/get';
import HydratorError from './error';
export var hydratePolymorphicData = function hydratePolymorphicData(hydrators, data, captureException) {
  if (data) {
    if ('__typename' in data) {
      var hydrator = hydrators[data.__typename];
      if (hydrator) {
        try {
          return hydrateData(data, hydrator);
        } catch (error) {
          captureException && captureException(new HydratorError({
            error: error,
            message: "Hydrator failed for [".concat(data.__typename, "].")
          }));
        }
      } else {
        captureException && captureException(new HydratorError({
          message: "Missing hydrator for [".concat(data.__typename, "].")
        }));
      }
    } else {
      captureException && captureException(new HydratorError({
        message: "Missing [__typename] field from data."
      }));
    }
  }
  return null;
};
function getOrSearch(object, path) {
  if (!object) {
    return object;
  }
  if (path.includes(':')) {
    var _path$split = path.split(':'),
      _path$split2 = _slicedToArray(_path$split, 2),
      searchField = _path$split2[0],
      searchValue = _path$split2[1];
    return findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, '') // Strip any preceding whitesepace and quotes
    );
  }
  return get(object, path);
}
function resolvePath(object, path) {
  // Split the path on each bracket
  var splitPath = path.split(/\(|\)./);

  // Traverse the split path as a tree, resolving as we go
  var current = object;
  var _iterator = _createForOfIteratorHelper(splitPath),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var split = _step.value;
      current = getOrSearch(current, split);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return current;
}
function findNodeByField(edges, fieldId, searchValue) {
  return edges.find(function (edge) {
    return get(edge, fieldId) === searchValue;
  });
}
export function getValues(object, paths) {
  return paths.map(function (path) {
    return resolvePath(object, path);
  });
}
var hydrateData = function hydrateData(data, hydrator) {
  var hydratorPaths = hydrator.hydratorPaths,
    staticFallbacks = hydrator.staticFallbacks;
  return _objectSpread({
    staticFallbacks: staticFallbacks
  }, Object.entries(hydratorPaths).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      dataValue = _ref2[1];
    var item = getValues(data, dataValue);
    if (item) {
      acc[key] = item;
    } else {
      throw new Error("Bad hydrator path: ".concat(key));
    }
    return acc;
  }, {}));
};